import MD5 from "crypto-js/md5";
import { MD5_SUFFIX_SALT } from "../../constants/text_constants";

export function verifyOTP(otp, hashedResponse) {
  const hashWithSalt = MD5(otp + MD5_SUFFIX_SALT).toString();
  return hashWithSalt === hashedResponse;
}
